import { render, staticRenderFns } from "./ClearCacheSettings.vue?vue&type=template&id=183b3bfe&"
import script from "./ClearCacheSettings.vue?vue&type=script&lang=ts&"
export * from "./ClearCacheSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports